import React, { Component } from 'react';
import EditMobileNumber from './EditMobileNumber';
import { Row, Col, Container, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import EirFieldset from '../../eirFieldset/EirFieldset'
import ContactUs from './ContactUs';
import Loading from '../../shared/Loading';
import PaymentDetails from './PaymentDetails';
import EirButton from '../../eir-button/EirButton';
import EirErrorModal from '../EirErrorModal';
import { subscriber, billing, csrSubscriber, csrBilling } from '../apis/accountManagementApis';
import AccountDetails from './AccountDetails';
import PaymentHistory from './PaymentHistory';

let subscriberStatus = '', billingStatus = ''

class AccountManagement extends Component {
    constructor(props) {
        super(props);
        this.state = {
            subscriber: '',
            email: sessionStorage.getItem('webmailLoggedinUser'),
            errorModal: false,
            loading: false,
            pendingCease: false,
            bill: '',
            oneOffPaymentMessage: false
        }
    }

    componentDidMount() {
        if (sessionStorage.getItem('webmailLoggedinUser') == null && !window.location.href.includes("opencms")) {
            window.location.href = '/email/login'
        }

        window.onbeforeunload = function () {
            sessionStorage.setItem("webmailLoggedinUser", this.state.email)
        }.bind(this);

        this.setState({
            loading: true
        })

        if (sessionStorage.getItem('WEBMAIL_AUTH_TOKEN') === '0_') {
            subscriberStatus = csrSubscriber;
            billingStatus = csrBilling;
        } else {
            subscriberStatus = subscriber;
            billingStatus = billing;
        }

        subscriberStatus.get(`/subscriber/${this.state.email}`)
            .then((response) => {
                this.setState({
                    subscriber: response.data,
                    loading: false
                })
                if (response.data.status === 'PENDING_ACTIVE') {
                    window.location.href = '/email/payment'
                }
                billingStatus.get(`${response.data.account}`)
                    .then((billing) => {
                        this.setState({
                            bill: billing.data
                        })
                    })
                    .catch((error) => {
                        console.log('error', error);
                        if (error.response.status === 403) {
                            return window.location.href = '/email/login'
                        }
                        this.setState({
                            errorModal: true,
                            loading: false
                        })
                    })
            })
            .catch((error) => {
                console.log('error', error);
                if (error.response.status === 403) {
                    return window.location.href = '/email/login'
                }
                this.setState({
                    errorModal: true,
                    loading: false
                })
            })

    }

    toggleError = (param) => {
        this.setState({
            errorModal: param
        })
    }

    updateMobileNumber = (param) => {
        if (param) {
            this.setState({
                loading: true
            })
            setTimeout(() => {
                subscriberStatus.get(`/subscriber/${this.state.email}`)
                    .then((response) => {
                        this.setState({
                            subscriber: response.data,
                            loading: false
                        })

                        billingStatus.get(`${response.data.account}`)
                            .then((billing) => {
                                this.setState({
                                    bill: billing.data
                                })
                            })
                            .catch((error) => {
                                console.log('error', error);
                                if (error.response.status === 403) {
                                    return window.location.href = '/email/login'
                                }
                                this.setState({
                                    errorModal: true,
                                    loading: false
                                })
                            })
                    })
                    .catch((error) => {
                        console.log('error', error);
                        if (error.response.status === 403) {
                            return window.location.href = '/email/login'
                        }
                        this.setState({
                            errorModal: true,
                            loading: false
                        })
                    })
            }, 500);

        }
    }

    messageUpdate = (param) => {
        if (param) {
            this.setState({
                oneOffPaymentMessage: !this.state.oneOffPaymentMessage
            })
        }
    }

    handleLogout = (e) => {
        e.preventDefault();
        sessionStorage.removeItem('webmailLoggedinUser');
        window.location.href = '/email/login';
    }
    render() {
        const { subscriber, loading, bill } = this.state
        return (
            <Container className='account-management-main'>
                <EirFieldset legend='Manage Your Account' border='solid'>
                    {
                        loading &&
                        <Loading />
                    }
                    <Row className='profile-details'>
                        <Col>
                            <Row>
                                <Col xs='12' sm='9' md='6' lg='10' className='welcome-name'>
                                    <h5>Welcome {subscriber.name},</h5>
                                </Col>
                                <Col xs='12' sm='3' md='6' lg='2'>
                                    <EirButton className='webmail-btn-logout edit-expiry' type='link' text='Logout' onClick={this.handleLogout} />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs='12' sm='12' md='6' lg='6'>
                                    <p><b>Email: </b>{subscriber.email}</p>
                                </Col>
                                <Col xs='12' sm='12' md='6' lg='6'>
                                    <p><b>Name: </b>{subscriber.name}</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs='12' sm='12' md='6' lg='6'>
                                    <EditMobileNumber subscriber={subscriber} updateMobileNumber={this.updateMobileNumber} />
                                </Col>
                                {/* Removing change password link as per the ticket EDQ-3963 
                                <Col xs='12' sm='12' md='6' lg='6' className='change-password'>
                                    <a target="_blank" rel="noopener noreferrer" className='change-password' href="https://autoreg.eir.ie/passwordchange/changeknown_pwd.html">Change Password</a>
                                </Col> */}
                            </Row>
                        </Col>
                    </Row>
                    {
                        (sessionStorage.getItem('WEBMAIL_AUTH_TOKEN') === 'disabled' && subscriber.status !== 'ACTIVE') &&
                        <Row>
                            <Col className='pt-4'>
                                <p>Please note your webmail account has been locked due to failed payment. Please make a payment below to unlock your account.</p>
                            </Col>
                        </Row>
                    }
                    {
                        subscriber.status === 'PENDING_CEASE' &&
                        <Row>
                            <Col className='pt-4'>
                                <p>We acknowledge your intention to cease and you will be officially ceased in 2 to 4 weeks from the date the request was received. You will lose all access to eircom.net email after that.</p>
                            </Col>
                        </Row>
                    }
                    {
                       // (subscriber.status === 'ARREARS' || subscriber.status === 'PENDING_CEASE'  || (sessionStorage.getItem('WEBMAIL_AUTH_TOKEN') === '0_')) && //commented for development
                        <Row>
                            <Col>
                                <EirFieldset legend='Account Details' border='dashed'>
                                    <AccountDetails subscriber={subscriber} bill={bill} subscriberCall={this.updateMobileNumber} oneOffPaymentMessage={this.messageUpdate} />
                                </EirFieldset>
                            </Col>
                        </Row>
                    }
                    <Row>
                        <Col>
                            <EirFieldset legend="Card Details" border='dashed'>
                                <PaymentDetails email={this.state.email} />
                            </EirFieldset>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <EirFieldset border='dashed'>
                                <PaymentHistory bill={bill} />
                            </EirFieldset>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs='12' sm='12' md='12' lg='12'>
                            <EirFieldset border='dashed'>
                                <ContactUs />
                            </EirFieldset>
                        </Col>
                    </Row>
                </EirFieldset>
                {
                    this.state.errorModal &&
                    <EirErrorModal toggleError={this.toggleError} errorModal={this.state.errorModal} />
                }

                <Modal isOpen={this.state.oneOffPaymentMessage} centered={true} toggle={this.messageUpdate}>
                    <ModalHeader toggle={this.messageUpdate}>Payment Success</ModalHeader>
                    <ModalBody>
                        Your payment has been successful.
                    </ModalBody>
                    <ModalFooter className='paymment-details-main'>
                        <EirButton className='webmail-btn' type='button' text='Close' onClick={this.messageUpdate}></EirButton>
                    </ModalFooter>
                </Modal>
            </Container>

        )
    }
}

export default AccountManagement;
